import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import App from "components/app";
import * as serviceWorker from "./serviceWorker";
import { Provider } from "react-redux";
import store from "./store";
import {
  BrowserRouter,
  Switch,
  Route,
  Redirect,
  withRouter,
} from "react-router-dom";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { useNotificationPolling } from "firebaseNotifications/useNotificationPolling";
import { routes } from "route";
import ConfigDB from "data/customizer/config";
import Signin from "./auth/signin";
import C_Signin from "./auth/cSignin";
import Register from "./auth/register";
// import RegisterForm from './auth/registerForm'
// import { ToastContainer } from "react-toastify";
import Notification from "./firebaseNotifications/Notification";
import MandatoryRedirector from "components/MandatoryRedirect/MandatoryRedirector";
// @ts-ignore
const RootComponent = withRouter((props) => {
  const abortController = new AbortController();
  const userId = localStorage.getItem("userId");
  const userRole = localStorage.getItem("userRole");

  useNotificationPolling(userId, userRole);

  // requestForToken();
  useEffect(() => {
    console.log(window.location.href);
    // @ts-ignore
    console.ignoredYellowBox = ["Warning: Each", "Warning: Failed"];
    // @ts-ignore
    console.disableYellowBox = true;
    return function cleanup() {
      abortController.abort();
    };
  }, [abortController]);

  var OwnerPosition = JSON.parse(localStorage.getItem("Position"));
  var authToken = localStorage.getItem("token");

  const devPaths = ["/login", "/register", "/cLogin"];
  const { location = {} } = props;
  const { pathname } = location;

  var url = window.location.href;
  var devPath = "/login";

  // var newUrl = url.split('/')
  // console.log(newUrl)
  // if (newUrl.length > 1 && newUrl[newUrl.length - 1] === "register") {
  //   devPath = "/register"
  // }else if(newUrl.length > 1 && newUrl[newUrl.length - 1] === "cLogin") {
  //   devPath = "/cLogin"
  // }

  // useEffect(() => {
  //   if(!authToken && !devPaths.includes(pathname)) {
  //     props.history.replace(devPath);
  //   }
  // }, [pathname]);

  return (
    <>
      <MandatoryRedirector />
      {!authToken && <Redirect to={devPath} />}
      <Switch>
        <Route path={`${process.env.PUBLIC_URL}/login`} component={Signin} />
        <Route path={`${process.env.PUBLIC_URL}/cLogin`} component={C_Signin} />
        <Route
          path={`${process.env.PUBLIC_URL}/register`}
          component={Register}
        />
        {/* <Route path={`${process.env.PUBLIC_URL}/registerForm`} component={RegisterForm} /> */}
        {/* <Route path={`${process.env.PUBLIC_URL}/callback`} render={() => <Callback />} /> */}
        <App>
          <TransitionGroup>
            {routes.map(({ path, Component }) => (
              <Route key={path} exact path={`${process.env.PUBLIC_URL}${path}`}>
                {/* {({ match }) => (
                    <CSSTransition
                      in={match != null}
                      timeout={100}
                      classNames={ConfigDB.data.router_animation}
                      unmountOnExit
                    > */}
                <div>
                  <Component />
                </div>
                {/* </CSSTransition>
                  )} */}
              </Route>
            ))}
          </TransitionGroup>
        </App>
      </Switch>
      <Notification />
    </>
  );
});

const Root = () => (
  <Provider store={store}>
    <BrowserRouter basename={`/`}>
      <RootComponent />
    </BrowserRouter>
  </Provider>
);

ReactDOM.render(<Root />, document.getElementById("root"));

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/firebase-messaging-sw.js")
      .then((reg) => {
        console.log("Firebase SW registered:", reg.scope);
      })
      .catch((err) => {
        console.error("SW registration failed:", err);
      });
  });
}
